import React, { memo, useEffect, useState } from "react";
import Loader from "../popups/Loading";

import "../report/report.css";
import "./Patient.css";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import { useSelector } from "react-redux";
import { Button, Card, Col, Form, Image, Modal, Row } from "react-bootstrap";
import CreateGroupClients from "../popups/CreateGroupClients";
import { AiOutlineSearch } from "react-icons/ai";
import { AutoComplete, DatePicker, Select } from "antd";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { globalColor, globalFont } from "../utils/RepeatFunctions/Schedule";
import axiosInstance from "../../axios/axios";
import { BsCheckCircle } from "react-icons/bs";
import {
  GetUserSearchData,
  SetUserSearchNoResult,
} from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  Table,
  TableBody,
  TableBodyCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from "../../StyledComponents";
import { Tablerow } from "./StyledComponent";
import edit_appointment from "../../assets/images/edit_appointment.png";
import delete_appointment from "../../assets/images/edit_appointment_delete.png";

const PatientGroupList = () => {
  const [spinner, setspinner] = useState(false);

  const [showGroupModal, setShowGroupModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const { RangePicker } = DatePicker;
  const [fromdt, setfrom] = useState(
    moment().add(-7, "days").format("YYYY-MM-DD")
  );
  const [todt, settodt] = useState(moment().format("YYYY-MM-DD"));

  const dispatch = useDispatch();

  const handleOpenGroupModal = () => setShowGroupModal(true);
  const handleCloseGroupModal = () => setShowGroupModal(false);

  const [usersearch, setUserSearch] = useState("");

  let storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");
  let authorized = Decrypt_Value(localStorage.getItem("authorized"), "vozo");
  let main_pro = Decrypt_Value(localStorage.getItem("main_pro"), "vozo");
  let owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  let user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  const dtFormat = localStorage.getItem("dateFormat");
  const dateFormat = localStorage.getItem("dateFormat");

  const [usersid, setuserid] = useState("");
  const [mainRows, setMainRows] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [offVal, setOffVal] = useState(40);
  const [loadFlag, setLoadFlag] = useState(0);
  const [showLoading, setShowLoading] = useState("reportDivblock");
  const [groupList, setGroupList] = useState([]);
  const [groupSearch, setGroupSearch] = useState("");
  const [groupId, setGroupId] = useState("");
  const [groupNoResult, setGroupNoResult] = useState("1");
  const [groupLoading, setGroupLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const [status, setStatus] = useState("");

  const UserSearchDatas = useSelector((state) => state.Schedule.UserSearchData);
  const UserSearchNoResult = useSelector(
    (state) => state.Schedule.UserSearchNoResult
  );

  const handleCreate = () => {
    setEditData(null);
    setShowGroupModal(true);
  };

  const handleEdit = (row) => {
    console.log(row);

    setEditData(row);
    setShowGroupModal(true);
  };

  // PROVIDER DROPDOWN
  const userdropdown = () => {
    let q =
      "limit=10&fname=" +
      usersearch +
      "&authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&owner_id=" +
      owner_id +
      "&userID=" +
      user_ID +
      "&pat_share=" +
      storedNames.pat_g;

    dispatch(GetUserSearchData(q));
  };

  const groupDropdown = () => {
    setGroupLoading(true);
    let article =
      "limit=10&search=" +
      groupSearch +
      "&authorized=" +
      authorized +
      "&main_pro=" +
      main_pro +
      "&owner_id=" +
      owner_id +
      "&userID=" +
      user_ID;

    let enc = Encrypt_Value(article, "vozo");

    axiosInstance
      .get("vozo/patientgroup/search?search=" + enc)
      .then((res) => {
        const data = Decrypt_Value(res.data, "vozo") || [];
        setGroupList(data);
        setGroupLoading(false);
      })
      .catch(() => {
        setGroupList([]);
        setGroupLoading(false);
      });
  };

  const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const GroupSelect = (value) => {
    const [id, name] = value.split("-");
    setGroupId(id);
    setGroupSearch(name);
  };

  const fetchAllGroupNames = async () => {
    try {
      const payload = {
        limit: 1000, // enough to get all groups
      };

      const enc = Encrypt_Value(payload, "vozo");

      const res = await axiosInstance.put("vozo/patientgroup/list", enc);

      const data = Decrypt_Value(res.data, "vozo") || [];
      setGroupList(data);
    } catch (err) {
      console.error("Failed to fetch group names", err);
      setGroupList([]);
    }
  };
  useEffect(() => {
    fetchAllGroupNames();
  }, []);

  // fetch data

  useEffect(() => {
    firstLoadGroups();
  }, []);

  // const fetchGroupList = async () => {
  //   try {
  //     const res = await axiosInstance.get("/api/vozo/patientgroup/list");
  //     setGroupList(res.data || []);
  //   } catch (error) {
  //     console.error("Error fetching group list", error);
  //   }
  // };
  const firstLoadGroups = async () => {
    setspinner(true);

    const payload = {
      group_name: "",
      provider_id: usersid,
      status: "",
      fromDate: fromdt,
      toDate: todt,
      limit: 40,
      offset: 0,
    };

    const encrypted = Encrypt_Value(payload, "vozo");
    const rows = [];

    axiosInstance
      .put("vozo/patientgroup/list", encrypted)
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozo");
        console.log(decrypted, "decrypted");

        decrypted.forEach((g) => rows.push(g));
        setMainRows(rows);

        // first 15 rows only
        setGroupData(decrypted.slice(0, 15));

        setShowLoading(
          decrypted.length > 15 ? "reportDivblock" : "reportDivnone"
        );

        setspinner(false);
      })
      .catch(() => {
        setGroupData([]);
        setspinner(false);
        setShowLoading("reportDivnone");
      });
  };

  // load more
  const loadMoreGroups = () => {
    setShowLoading("reportDivblock");

    let rowsCount = groupData.length;
    let finalRows = [...mainRows];

    if (finalRows.length === rowsCount) {
      setShowLoading("reportDivnone");
      return;
    }

    if (rowsCount >= offVal - 30 && loadFlag === 0) {
      setLoadFlag(1);
      setOffVal((v) => v + 40);

      const payload = {
        group_id: groupId || "",
        group_name: groupSearch || "",
        provider_id: usersid,
        status: "",
        fromDate: fromdt,
        toDate: todt,
        limit: 40,
        offset: offVal,
      };

      const encrypted = Encrypt_Value(payload, "vozo");

      axiosInstance
        .put("/api/vozo/patientgroup/list", encrypted)
        .then((res) => {
          const decrypted = Decrypt_Value(res.data, "vozo");
          setLoadFlag(0);
          setMainRows((prev) => [...prev, ...decrypted]);
        });
    }

    let items = [];
    let end = rowsCount + 10;

    for (let i = rowsCount; i < end; i++) {
      if (finalRows[i]) items.push(finalRows[i]);
    }

    setGroupData((prev) => [...prev, ...items]);
  };

  // onUpdate

  const onUpdate = () => {
    setOffVal(40);
    setLoadFlag(0);
    setspinner(true);

    const payload = {
      group_id: groupId || "",
      group_name: groupSearch || "",
      provider_id: usersid,
      status: status,
      fromDate: fromdt,
      toDate: todt,
      limit: 40,
      offset: 0,
    };

    // console.log("updatePayload", payload);

    const encrypted = Encrypt_Value(payload, "vozo");

    axiosInstance
      .put("vozo/patientgroup/list", encrypted)
      .then((res) => {
        const decrypted = Decrypt_Value(res.data, "vozo");

        setMainRows(decrypted);
        setGroupData(decrypted.slice(0, 15));

        setShowLoading(
          decrypted.length > 15 ? "reportDivblock" : "reportDivnone"
        );
        setspinner(false);
      })
      .catch(() => {
        setGroupData([]);
        setspinner(false);
      });
  };

  const fetchGroupList = async () => {
    try {
      const res = await axiosInstance.get("/api/vozo/patientgroup/list");
      setGroupList(res.data || []);
    } catch (error) {
      console.error("Error fetching group list", error);
    }
  };

  const handleDelete = (group_id) => {
    if (!window.confirm("Delete this patient group?")) return;

    axiosInstance
      .get(`vozo/patientgroup/delete?id=${group_id}`)
      .then(() => {
        setSuccessMsg("Patient Group deleted successfully");
        setShowSuccess(true);

        setGroupSearch("");
        setGroupId("");

        firstLoadGroups();
        fetchAllGroupNames();

        setTimeout(() => {
          setShowSuccess(false);
          setSuccessMsg("");
        }, 2000);
      })
      .catch(() => {
        setSuccessMsg("Failed to delete patient group");
        setShowSuccess(true);

        setTimeout(() => {
          setShowSuccess(false);
          setSuccessMsg("");
        }, 2000);
      });
  };

  useEffect(() => {
    let cancel = false;

    const handler = async () => {
      await new Promise((r) => setTimeout(r, 600));
      if (!cancel && usersearch !== "") {
        userdropdown(); // existing function
      }
    };

    handler();
    return () => (cancel = true);
  }, [usersearch]);

  return (
    <>
      {spinner ? (
        <Loader />
      ) : (
        <div>
          <>
            <div>
              <>
                <div
                  className="tab_title_main1"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h1> Patient Group List</h1>
                  <Button
                    variant="primary"
                    className="save_active create-cli"
                    onClick={handleOpenGroupModal}
                    style={{
                      whiteSpace: "nowrap",
                      minWidth: "auto",
                      padding: "6px 16px",
                      width: "auto",
                      fontWeight: "600",
                      fontSize: "14px",
                      fontStyle: "semibold",
                    }}
                  >
                    Create Patient Group
                  </Button>
                </div>

                {/* filter */}

                <div className="backgr-chng for-eligibility-author">
                  <div className="eligibility-snd-layer rep-flex-align-center">
                    {/* patient Group search */}
                    <div className="for_autoComplete_bi ElligibiltyProductSearch">
                      <AiOutlineSearch />
                      <AutoComplete
                        virtual={false}
                        placeholder="Group Name"
                        className="remainderWidthSheet"
                        value={groupSearch}
                        onChange={(v) => {
                          setGroupSearch(v);
                          if (!v) setGroupId("");
                        }}
                        onSelect={GroupSelect}
                        options={groupList.map((g) => ({
                          label: g.group_name,
                          value: g.group_id + "-" + g.group_name,
                        }))}
                      />
                    </div>
                    {/* provider */}
                    <div className="for_autoComplete_bi ElligibiltyProductSearch">
                      <AiOutlineSearch />
                      <AutoComplete
                        virtual={false}
                        placeholder="Provider"
                        className="remainderWidthSheet"
                        value={usersearch}
                        onChange={(v) => {
                          setUserSearch(v);
                          dispatch(SetUserSearchNoResult("1"));
                          if (v === "") setuserid("");
                        }}
                        onSelect={(v) => {
                          const arr = v.split("-");
                          setUserSearch(arr[1]);
                          setuserid(arr[0]);
                        }}
                        onFocus={() => {
                          // Load providers when dropdown is clicked/focused
                          if (
                            usersearch === "" &&
                            UserSearchDatas.length === 0
                          ) {
                            userdropdown(); // This calls your existing userdropdown function
                          }
                        }}
                        notFoundContent={
                          UserSearchNoResult !== ""
                            ? "Loading..."
                            : "No Results Found"
                        }
                        options={UserSearchDatas.map((x) => ({
                          value: x.id + "-" + x.title,
                          label: x.title,
                        }))}
                      />
                    </div>

                    {/* status */}
                    <div className="tele-select-btn m-l-25  p-t-14">
                      <Select
                        placeholder="Status"
                        className="w-210 t-a-l antd-dd-tele_repo ant-sel-hei34 antd-dd-pay_anly"
                        value={status || undefined}
                        onChange={(value) => setStatus(value)}
                      >
                        <Select.Option value="Active">Active</Select.Option>
                        <Select.Option value="Inactive">Inactive</Select.Option>
                        <Select.Option value="Expired">Expired</Select.Option>
                      </Select>
                    </div>
                    {/* date */}
                    <div className="ds-flex1" id="rpt_pay-inp_dt">
                      <RangePicker
                        allowClear={false}
                        getPopupContainer={(n) => n.parentNode}
                        defaultValue={[
                          moment(fromdt, "YYYY-MM-DD"),
                          moment(todt, "YYYY-MM-DD"),
                        ]}
                        format={dateFormat}
                        onChange={(v) => {
                          if (v) {
                            setfrom(moment(v[0]).format("YYYY-MM-DD"));
                            settodt(moment(v[1]).format("YYYY-MM-DD"));
                          }
                        }}
                      />
                    </div>

                    {/* UPDATE BTN */}
                    <div className="rep-day-sht-btn m-t-8">
                      <Button variant="primary" onClick={onUpdate}>
                        Update
                      </Button>
                    </div>
                  </div>
                </div>

                {/* TABLE */}
                <div className="appoint_report_card prior_rep_card_table">
                  <Card>
                    <div className="bill_summary_table">
                      <Table margin="20px 0px 0px 0px">
                        <TableHead
                          className="Tab_content_Table_Header appt-head "
                          display="table-header-group"
                          height="40px"
                        >
                          <TableRow
                            className="schedule-head-row tr-no"
                            fontWeight="400"
                            color={globalColor}
                          >
                            <TableHeadCell padding="20px 0px 20px 20px">
                              Group Name
                            </TableHeadCell>

                            <TableHeadCell>Group ID</TableHeadCell>

                            <TableHeadCell>Status</TableHeadCell>

                            <TableHeadCell>Patient #</TableHeadCell>

                            <TableHeadCell>Provider</TableHeadCell>

                            <TableHeadCell>Start Date</TableHeadCell>

                            <TableHeadCell>End Date</TableHeadCell>

                            <TableHeadCell paddingRight="20px">
                              Action
                            </TableHeadCell>
                          </TableRow>
                        </TableHead>

                        <TableBody className="tble-over appt_tab_alt1">
                          {groupData.length > 0 ? (
                            groupData.map((row, index) => (
                              <TableRow
                                key={index}
                                className="table-data-row schedule-body-row"
                                fontFamily={globalFont}
                                borderBottom="1px solid #cbd5e0"
                                color="#636d73"
                                height="56px"
                              >
                                <TableBodyCell padding="14px 0px 14px 20px">
                                  <span title={row.group_name}>
                                    {row.group_name.length > 15
                                      ? row.group_name.slice(0, 15) + "..."
                                      : row.group_name}
                                  </span>
                                </TableBodyCell>

                                <TableBodyCell content="center">
                                  {row.group_id}
                                </TableBodyCell>

                                <TableBodyCell>{row.status}</TableBodyCell>

                                <TableBodyCell content="right">
                                  {row.patient_count}
                                </TableBodyCell>

                                <TableBodyCell>
                                  <span title={row.provider_name}>
                                    {row.provider_name.length > 15
                                      ? row.provider_name.slice(0, 15) + "..."
                                      : row.provider_name}
                                  </span>
                                </TableBodyCell>

                                <TableBodyCell>{row.start_date}</TableBodyCell>

                                <TableBodyCell>{row.end_date}</TableBodyCell>

                                <TableBodyCell
                                  style={{ display: "flex", gap: "10px" }}
                                >
                                  <img
                                    src={edit_appointment}
                                    alt="edit"
                                    onClick={() => handleEdit(row)}
                                    style={{ cursor: "pointer" }}
                                  />
                                  <img
                                    src={delete_appointment}
                                    alt="delete"
                                    onClick={() => handleDelete(row.group_id)}
                                    style={{ cursor: "pointer" }}
                                  />
                                </TableBodyCell>
                              </TableRow>
                            ))
                          ) : (
                            <>
                              <Tablerow className="bot_border">
                                <TableBodyCell
                                  className="appCellCenter patpor_main_div"
                                  colSpan={8}
                                >
                                  <div className="img_top">
                                    <Image
                                      height="133px"
                                      width="133px"
                                      src={Emp_data_pic}
                                    ></Image>
                                  </div>
                                </TableBodyCell>
                              </Tablerow>
                            </>
                          )}
                        </TableBody>
                      </Table>
                      {groupData.length !== 0 && (
                        <div className={"loading-more " + showLoading}>
                          <Button variant="primary" onClick={loadMoreGroups}>
                            Load more...
                          </Button>
                        </div>
                      )}
                    </div>
                  </Card>
                </div>
              </>
            </div>
          </>
        </div>
      )}
      <Modal
        className="client-popup create-client create_modaltop wid_562"
        centered
        show={showGroupModal}
        onHide={() => {
          setShowGroupModal(false);
          setEditData(null);
        }}
      >
        <CreateGroupClients
          onClose={() => {
            setShowGroupModal(false);
            setEditData(null);
          }}
          editData={editData}
          onSuccess={(msg) => {
            setSuccessMsg(msg);
            setShowSuccess(true);
            firstLoadGroups();
            fetchAllGroupNames();
            setTimeout(() => {
              setShowSuccess(false);
              setSuccessMsg("");
            }, 2000);
          }}
        />
      </Modal>
      <Modal
        className="alert-popup-message"
        show={showSuccess}
        onHide={() => setShowSuccess(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {successMsg}
        </div>
      </Modal>
    </>
  );
};

export default PatientGroupList;
